import {
  createTranslationMessages,
  createTranslationResource,
} from '@backstage/core-plugin-api/alpha';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';

const en = createTranslationMessages({
  ref: scaffolderTranslationRef,
  full: false, // False means that this is a partial translation
  messages: {
    'templateFormPage.title': 'Create a new service 111',
    'templateListPage.contentHeader.registerExistingButtonTitle':
      'Register Existing Service',
  },
});

export const scaffolderTranslations = createTranslationResource({
  ref: scaffolderTranslationRef,
  translations: {
    en: async () => ({ default: en }),
  },
});
